<template>
    <div class="filters-container">
        <notification class="info" icon-name="info-circle" icon-class="info-message">
            <p>By default synchronization profile has no filters and all issues and work items are synchronized.<br/>
                When there is only one filter for Jira / TFS then these issues / work items that match this filter are
                synchronized.
            </p>
        </notification>
        <ProfileFilterSection
            :dictionary="{
                filterType: 'Jira',
                language: {
                    name: 'Jira Query Language',
                    abbreviation: 'JQL',
                    docs: 'https://support.atlassian.com/jira-software-cloud/docs/use-advanced-search-with-jira-query-language-jql/'
                }
            }"
        />
        <ProfileFilterSection
            :dictionary="{
                filterType: 'TFS',
                language: {
                    name: 'Work Item Query Language',
                    abbreviation: 'WIQL',
                    docs: 'https://docs.microsoft.com/en-us/azure/devops/boards/queries/wiql-syntax?view=azure-devops'
                }
            }"
        />
        <button @click="handleSaveButtonPress($event)" type="button" class="save-settings-button"
                :disabled="!isSaveButtonEnabled" :aria-disabled="!isSaveButtonEnabled">Save settings
        </button>
        <div v-show="loaderVisible" class="spinner"/>
    </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import {NAMESPACE as APP_NAMESPACE} from '../../../store/modules/app.js';
import Notification from './../../Notification';
import ProfileFilterSection from "./ProfileFilterSection";
import ProfileFiltersService from "../../../service/profileFilters.js";
import axios from 'axios';

export default {
    components: {
        ProfileFilterSection,
        Notification,
    },
    props: {
        profileGuid: {
            type: String,
            required: true,
        },
        loadOnInit: {
            type: String,
        },
    },
    data() {
        return {
            savedSettings: this.getCurrentSettings(),
        };
    },
    computed: {
        ...mapGetters({contextPath: APP_NAMESPACE.getters.CONTEXT_PATH}),
        ...mapGetters('profileFilters', [
            'loaderVisible',
            'jiraFilteringEnabled',
            'azureFilteringEnabled',
            'jqlFilterText',
            'wiqlFilterText',
            'loaderVisible',
        ]),
        isSaveButtonEnabled() {
            return (
                (Boolean(this.wiqlFilterText) || !this.azureFilteringEnabled)
                && Boolean((this.jqlFilterText) || !this.jiraFilteringEnabled)
            );
        },
    },
    mounted: function () {
        if (this.loadOnInit !== undefined && this.loadOnInit === 'true') {
            this.initComponent();
        }
    },
    methods: {
        ...mapActions('profileFilters', ['setService', 'fetchSavedSettings', 'saveSettings']),
        getCurrentSettings() {
            return {
                jiraFilteringEnabled: this.jiraFilteringEnabled,
                azureFilteringEnabled: this.azureFilteringEnabled,
                jqlFilterText: this.jqlFilterText,
                wiqlFilterText: this.wiqlFilterText,
            };
        },
        initComponent: async function () {
            this.setService({
                service: new ProfileFiltersService(axios, `${this.contextPath}/api/profiles/${this.profileGuid}`),
            });

            await this.fetchSavedSettings();
            this.savedSettings = this.getCurrentSettings();

            this.loadOnInit = 'true';
        },
        async handleSaveButtonPress() {
            const success = await this.saveSettings(this.getCurrentSettings());
            if (success) {
                this.savedSettings = this.getCurrentSettings();
            }
        },
    }
}
</script>
<style scoped>
@import '../../../assets/css/common.css';

.filters-container > article:first-of-type.filter-section {
    margin-top: 30px;
}

.filters-container > .filter-section::after {
    content: "";
    display: block;
    margin-top: 50px;
    border-bottom: 1px solid #ebecf0;
}

.save-settings-button {
    font-size: 1.2em;
    padding: 0.2em 0.4em;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/filters/ProfileFilters.vue